import React, {useState} from "react";
import {Label} from "reactstrap";
import API from "../../../utils/API";

const BordeloConnectForm = ({id,bordeloId,bordeloApiKey,close}) => {
    const [formBordeloId, setFormBordeloId] = useState(bordeloId)
    const [formBordeloApiKey, setFormBordeloApiKey] = useState(bordeloApiKey)

    const save = () => {
        API.post(`/admin/bordelo/publisherrcid/${id}`, {bordeloid:formBordeloId,bordeloapikey:formBordeloApiKey}).then((response) => {
            close()
        });
    }

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <Label>Bordelo Id</Label>
                    <input className="form-control" onChange={(e)=>setFormBordeloId(e.target.value)} type="text"
                           value={formBordeloId} placeholder="Enter Bordelo Id"/>
                </div>
                <div className="col">
                    <Label>Bordelo API Key</Label>
                    <input className="form-control" onChange={(e)=>setFormBordeloApiKey(e.target.value)} type="text"
                           value={formBordeloApiKey} placeholder="Enter Bordelo API Key"/>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col text-center">
                    <button className="btn btn-primary" onClick={save}>Save</button>
                </div>
            </div>
        </>
    )
}

export default BordeloConnectForm
